import { createSelector } from '@ngrx/store';
import { DYNAMIC_PAGES_FEATURE_KEY, State } from './dynamic-pages.reducer';

export const getState = (state: {
    [DYNAMIC_PAGES_FEATURE_KEY]: State;
}): State => state[DYNAMIC_PAGES_FEATURE_KEY];

export const getLatestEvent = createSelector(getState, (state: State) =>
    state?.events?.length ? state.events[state.events.length - 1] : undefined,
);
